import React from 'react'; 
import PropTypes from 'prop-types';

const PreferredServiceWeek = ({scheduleDate}) => {
    return (
        <div className="form-group">
            <p>{window.osa.lookup.submitRequest.preferredServiceWeek}</p>
            <h4 className="text-primary"><b>{scheduleDate}</b></h4>
            {    
                //<p className="paragraph" ng-if="offRampMessage !=''">{p.props.FortisSummanyMessage}</p>
            }
        </div>
    );
};
PreferredServiceWeek.propTypes = {
    scheduleDate: PropTypes.string,
};
export default PreferredServiceWeek;